var _rect, _rect2, _rect3, _path, _path2, _rect4, _path3, _path4, _rect5, _path5, _path6, _rect6, _path7, _path8, _rect7, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStarRate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 37,
    viewBox: "0 0 206 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 37,
    fill: "#E6DEDE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 4022,
    transform: "translate(-88 -2740)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 36.6365,
    height: 36.6365,
    fill: "#00B87C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7402 15.5878L21.2823 15.5878L18.3708 6.59509L15.4421 15.5878L5.98425 15.5706L13.6333 21.1351L10.7046 30.1278L18.3536 24.5634L26.0026 30.1278L23.0912 21.1351L30.7402 15.5878Z",
    fill: "#FDFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7461 23.1672L23.0915 21.1343L18.3712 24.5626L23.7461 23.1672Z",
    fill: "#4BBD97"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1323,
    width: 36.6365,
    height: 36.6365,
    fill: "#00B87C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.872 15.5878L63.4141 15.5878L60.5027 6.59509L57.574 15.5878L48.1161 15.5706L55.7651 21.1351L52.8364 30.1278L60.4854 24.5634L68.1344 30.1278L65.223 21.1351L72.872 15.5878Z",
    fill: "#FDFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.878 23.1672L65.2233 21.1343L60.503 24.5626L65.878 23.1672Z",
    fill: "#4BBD97"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2642,
    width: 36.6365,
    height: 36.6365,
    fill: "#00B87C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.004 15.5878L105.546 15.5878L102.635 6.59509L99.7059 15.5878L90.248 15.5706L97.897 21.1351L94.9683 30.1278L102.617 24.5634L110.266 30.1278L107.355 21.1351L115.004 15.5878Z",
    fill: "#FDFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.01 23.1672L107.355 21.1343L102.635 24.5626L108.01 23.1672Z",
    fill: "#4BBD97"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 126.396,
    width: 36.6365,
    height: 36.6365,
    fill: "#00B87C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.136 15.5878L147.678 15.5878L144.766 6.59509L141.838 15.5878L132.38 15.5706L140.029 21.1351L137.1 30.1278L144.749 24.5634L152.398 30.1278L149.487 21.1351L157.136 15.5878Z",
    fill: "#FDFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.142 23.1672L149.487 21.1343L144.767 24.5626L150.142 23.1672Z",
    fill: "#4BBD97"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 168.528,
    width: 36.6365,
    height: 36.6365,
    fill: "#00B87C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.268 15.5878L189.81 15.5878L186.899 6.59509L183.97 15.5878L174.512 15.5706L182.161 21.1351L179.233 30.1278L186.882 24.5634L194.531 30.1278L191.619 21.1351L199.268 15.5878Z",
    fill: "#FDFEFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.274 23.1672L191.619 21.1343L186.899 24.5626L192.274 23.1672Z",
    fill: "#4BBD97"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarRate);
export default __webpack_public_path__ + "static/media/icon_star_rate.7350d8f7f29bd0aea80e42aaba7073c3.svg";
export { ForwardRef as ReactComponent };